import React,{ useCallback, useEffect } from "react";
import { useState } from "react";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { getList, resetApiStatus, updateStatus } from "../../slices/LeaveSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import defaultConfig from "../../config/Config";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import { downloadLeaves } from "../../services/reports"
import { startDownload } from "../../Utils/utils/CommanFnc";
import { Loading } from "../../components/Loading"
import ModelBox from "../../common/ModelBox";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormError } from "../../components/FormError";
import Modal from 'react-bootstrap/Modal';
import * as Yup from "yup";
import SelectBox  from "../../components/admin/SelectBox"
import { ToSelectOption } from "../../Utils/utils/CommanFnc";
import { MessageAlert } from "../../components/admin/MessageAlert";

export function List() {
    const [todayDate, setTodayDate] = useState(moment(new Date()).format('YYYY-MM-DD') ) 
    const [pageName, setPageName] = useState('');
    const [leavesData, setLeavesData] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams()
    const [pageTitle, setPageTitle] = useState('')
    const [downloadLoading, setDownloadLoading] = useState(false)
    const [userLeaves, setUserLeaves] = useState([]);
    const [activeUserId, setActiveUserId] = useState(null);
    const [selectedUserName, setSelectedUserName] = useState('');
    const [dateToDisplay, setDateToDisplay] = useState({});
    const [downloadOpt, setDownloadOpt] = useState([]);
    const [modelData, setModelData] = useState({})
    const [modelContent, setModelContent] = useState("")
    const [leaveStatus, setLeaveStatus] = useState([])
    const [msgCompId, setMsgCompId] = useState('');
    const [currentLoggeInUserId, setCurrentLoggeInUserId] = useState(null);
    const [defaultParams, setDefaultParams] = useState({
        date: '',
        endDate: '',
        parentUserId: '',
        all: true,
        userId: ''
    })
    const dispatch = useDispatch(); 
    const navigate = useNavigate();

    const loggeInUserId = useSelector( (state) => state?.auth?.authData?.user?._id );
    const data = useSelector((state) => state.leaves);
    const loading = useSelector( (state) => state.leaves.loading);
    const leavesProps = useSelector( (state) => state.leaves)

    const queryString = Object.fromEntries([...searchParams.entries()]);
    const [serachString, setSearchString] = useState({
        date: queryString.date? queryString.date : '',
        endDate: queryString.endDate? queryString.endDate : ''
    })
    const location = useLocation();
    const formSchema = Yup.object().shape({
        status: Yup.string().required("Please select status"),
        rejectReason: Yup.string().required("Please enter comment"),
    });
    const {
        register,
        handleSubmit,
        setValue,
        control,
        formState: { errors },
      } = useForm({
        mode: "onBlur",
        resolver: yupResolver(formSchema),
      });

    useEffect( () => {
        setDownloadOpt(() => {
          let opt = Object.keys(dateToDisplay).length > 0? [{
                      value: "download-month",
                      label: `All Team ${dateToDisplay.startDate} To ${dateToDisplay.endDate}`
                    }] : [] ;
          if ( selectedUserName ) {
            opt.push({
              value: 'download-user',
              label: selectedUserName
            });
          }
          
          return opt;
    
        })
      }, [selectedUserName, serachString.date, serachString.endDate])

    useEffect( () => {
        setPageName(location.pathname)
        setTodayDate(moment(new Date()).format('YYYY-MM-DD'))
    },[location])

    const getMaxDate = function() {
        const nextDate = moment(Date.parse(serachString.date)).add(1, 'M');
        return Date.parse(nextDate);
    }

    useEffect(()=>{
        const params = {
            ...defaultParams,
            ...queryString
        };
        setCurrentLoggeInUserId(loggeInUserId);
        setLeaveStatus(ToSelectOption(defaultConfig.leavesStatus, {value: 'value', label: 'label'}));
        switch(pageName){
            case '/team-leaves-request':
                params.parentUserId = queryString.parentUserId? queryString.parentUserId : ''
                setDefaultParams({...defaultParams, ...{parentUserId: params.parentUserId}})
                setPageTitle('My Team Leave Request')
                break;
            case '/all-leaves-request':
                params.parentUserId = queryString.parentUserId? queryString.parentUserId : ''
                setDefaultParams({...defaultParams, ...{parentUserId: params.parentUserId}})
                setPageTitle('All Leaves Request')
            break;
            case '/my-leaves-request':
                params.userId = loggeInUserId || '';
                setDefaultParams({...defaultParams, ...{userId: params.userId}})
                setPageTitle('My Leaves Request')
            break;
        }
        setSearchString(params)
        dispatch(getList({data: params}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[dispatch, pageName]);

    useEffect( ()=>{
        const { list, date } = data;
        const attendance = list?.find( (item) => item.userId === activeUserId );
        setDateToDisplay(() => {
            return {
              startDate: moment(date?.startDate).format("MMMM, DD YYYY"),
              endDate: moment(date?.endDate).format("MMMM, DD YYYY")
            }
        });
        setLeavesData(list);
        setUserLeaves(attendance?.userLeaves);
        setSelectedUserName(attendance?.name || '')
    },[data.list])

    const onDateChange = (value, name) => {
        const query = {...serachString, [name]: value};
        if(name !== "endDate") {
            query.endDate = null;
        }
        setSearchString({...serachString, ...query})
    }

    const searchInt = () => {
        if(moment(serachString.date).isValid() && moment(serachString.endDate).isValid()){
            setUserLeaves([]);
            let params = Object.assign(defaultParams, {pageLength: defaultConfig.defaultLimit, page:1, ...serachString})
            setSearchParams(params)  
            params.date = moment(Date.parse(params.date)).format('YYYY-MM-DD')
            params.endDate = moment(Date.parse(params.endDate)).format('YYYY-MM-DD')
            dispatch(getList({data:{...params}}))
        }   
    }

    const resetSearch = () =>{
        const date = '';
        const endDate = '';
        const queryPrm = {...defaultParams};
        setSearchParams(queryPrm);
        setSearchString({ date, endDate }); 
        dispatch(getList({data:{...queryPrm}}));
    }

    const downloadReport = async (downloadType) => {
        setDownloadLoading(true);
        const startDate = moment(Date.parse(serachString.date)).format('YYYY-MM-DD');
        const endDate   = moment(Date.parse(serachString.endDate)).format('YYYY-MM-DD');
        const params    = {...serachString};
        let fileName    = `leaves-report-${startDate}-${endDate}.xlsx`;
        switch (downloadType) {
            case 'download-user':
              fileName = `${selectedUserName}-${fileName}`;
              params.parentUserId = '';
              params.userId = activeUserId;
            break;
            default:
              params.userId = '';
              params.parentUserId = '';
              fileName = `All-Team-${fileName}`
        }
        const excelData = await downloadLeaves(params);
        startDownload(excelData, fileName);
        setDownloadLoading(false);
    }

    const showLeaves = (currentItem) => {
        setSelectedUserName(currentItem?.name);
        setUserLeaves(currentItem?.userLeaves);
        setActiveUserId(currentItem?.userId);
    }

    const staffTeam = () => {
        const queryString  = new URLSearchParams({...serachString, parentUserId: activeUserId, all: true }).toString()
        navigate(`/team-leaves-request?${queryString}`);
        window.location.reload(true);
    }

    const closeModel = useCallback(() =>{
        setModelData({
            ...modelData,
            show:false
        })
        setModelContent("")
    },[modelData])

    useEffect( ()=>{
        if(leavesProps.actionType === "LEAVE_UPDATE"){
            closeModel()
            dispatch(resetApiStatus())
            setTimeout( () =>{
                dispatch(getList({data:{...defaultParams, pageName}}))
            }, 10)
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[closeModel, dispatch, leavesProps.actionType, pageName])

    const onSubmit = (data) => {
        setMsgCompId(new Date().getTime())
        dispatch(updateStatus(data))
    }

    const getModelContent = useCallback( (data) => {
        setValue('leaveId', data._id)
        setValue('status', data.status)
        setValue('rejectReason', data.rejectReason)
        setModelContent(
            <React.Fragment>
            <form className="pb-0 mb-0" onSubmit={handleSubmit(onSubmit)}>
                <input
                    {...register("leaveId")}
                    type="hidden"
                />
                <Modal.Body>
                <div className="formDiv">
                    <div className="row">
                    <div className="col-3">
                            <div className="form-group mb-3">
                            <label
                                className={`input-label`}
                            >
                                Employe Name
                            </label>
                            <p className="lead">{data?.userDetail.name}</p>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group mb-3">
                            <label
                                className={`input-label`}
                            >
                                Start Date
                            </label>
                            <p className="lead">{moment(data?.from).format('LL')}</p>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group mb-3">
                            <label
                                className={`input-label ${errors.title && "error"}`}
                            >
                                End Date
                            </label>
                            <p className="lead">{moment(data?.to).format('LL')}</p>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group mb-3">
                                <label
                                    className={`input-label`} >
                                    Status
                                </label>
                                <Controller
                                    control={control}
                                    name="status"
                                    render={({ field: { value, onChange } }) => (
                                    <SelectBox
                                        options={leaveStatus}
                                        isClearable={true}
                                        onChange={(opt) => onChange(opt?.value)}
                                        value={leaveStatus.find(
                                            (option) => option.value === value
                                        )}
                                    />
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group mb-3">
                                <label
                                    className={`input-label`}>
                                    Leave Reason
                                </label>
                                <p className="lead">{data?.leaveReason}</p>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div className="row">
                        <div className="col-8">
                            <div className="form-group mb-3">
                                <label
                                    className={`input-label ${errors.rejectReason && "error"}`}
                                >
                                    Comment
                                </label>
                                <textarea
                                    {...register("rejectReason")}
                                    type="text"
                                    id="floatingTextarea2" 
                                    style={{"height":"100px"}}
                                    className={`form-control ${
                                    errors.title && "error"
                                    }`}
                                />
                                {errors.coin && (
                                    <FormError message={errors.rejectReason.message} />
                                )}
                            </div>
                        </div>                
                    </div>
                </div>
                </Modal.Body>
                <Modal.Footer>
                <div className="col-12 mb-3 text-right">
                    <button type="button" onClick={closeModel} className="btn btn-outline-danger btn-lg mx-2">
                    Cancel
                    </button>        
                    <button type="submit" disabled={loading} className="btn btn-outline-success btn-lg mx-2">
                    {loading?"Updating...":"Update"}
                    </button>
                </div>
                </Modal.Footer>
            </form>
            
            </React.Fragment>
        )
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[data, errors])

    const openEditPage = useCallback( (data) => {
        setModelData({
            data,
            show:true,
            size:"lg"
        })
        getModelContent(data)
    },[getModelContent])

    return (
        <React.Fragment>
        { downloadLoading || loading? <Loading/>: ''}
        <div className="revenue-wrapper">
            <div className="row">
            <div className="col-lg-12">
                <div className="card table-card">
                <div className="d-sm-flex justify-content-between align-items-center pl-4 pr-4">
                    <h4 className="card-title mB25 mb-sm-0"><i className="fas fa-clock"></i> { pageTitle} 
                    </h4>
                </div>
                <div className="row p-5">
                    <div className="col-md-9">  
                        <form className="form-inline">
                            <div className="form-group">
                            <div className="mr-1">
                                <label style={{'justifyContent':'left'}} className="text-left">Start Date</label>
                                <DatePicker 
                                showMonthDropdown 
                                showYearDropdown 
                                className="form-control" 
                                selected={serachString.date?Date.parse(serachString.date):''} 
                                maxDate={Date.parse(todayDate)}
                                onChange={(date) => onDateChange(moment(Date.parse(date)).format('YYYY-MM-DD'), 'date')}
                                />  
                                </div>
                            <div className="mr-1">
                                <label style={{'justifyContent':'left'}}>End Date</label>
                                <DatePicker
                                selected={serachString.endDate?Date.parse(serachString.endDate):''}
                                className="form-control"
                                onChange={(date) => onDateChange(moment(Date.parse(date)).format('YYYY-MM-DD'), 'endDate')}
                                minDate={Date.parse(serachString.date)}
                                showMonthDropdown
                                showYearDropdown
                                maxDate={getMaxDate(todayDate)}
                                />
                            </div>
                            </div>
                            <div >
                            <label>&nbsp;</label>
                            <button onClick={searchInt} type="button" className="btn btn-primary btn-lg">
                                <i className="fa fa-search"></i>
                            </button>
                            &nbsp;
                            <button type="reset" onClick={resetSearch} title="Reset" className="btn btn-primary btn-lg">
                                <i className="fas fa-undo"></i>
                            </button>
                            </div>
                        
                        </form>
                    </div>
                    {
                        leavesData?.length > 0 ? 
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="d-block">Download Report</label>
                                    <SelectBox 
                                        options={downloadOpt}
                                        onChange={ (e) =>  downloadReport(e.value)}
                                    />
                                </div>
                            </div> : '' 
                    }
                </div>
                <div className="container-fluid">
                    <div className="row">
                    {
                        leavesData?.length > 0 ?
                        <>
                            <div className="col-sm-3">
                            <ul className="user-list">
                                {
                                leavesData?.map((item, index) => {
                                    return <li className={activeUserId === item.userId? "active": ''} key={`user-list-${index}`}> 
                                            <span onClick={()=>showLeaves(item)}> {item.name}</span>
                                        </li>
                                })
                                }
                            </ul>
                            </div>
                            <div className="col-sm-9">
                            {selectedUserName? 
                            <div className="row">
                                <div className="col-sm-8">
                                    <h2>{selectedUserName?.trim() || ''} &nbsp; { <small>{dateToDisplay?.startDate} TO {dateToDisplay?.endDate}</small>  } </h2>
                                </div>
                                <div className="col-sm-4 text-right" style={{'marginLeft':'auto'}}>
                                { selectedUserName && pageName !== "/my-leaves-request"
                                        ? <button onClick={()=>staffTeam()} className="btn btn-success"> View Team Leaves </button> 
                                        : ''
                                }
                                </div>
                            </div> : '' }
                            <div className="table-responsive datatable-wrap">
                                <table className="table dataTable table-hover">
                                <thead>
                                    <tr>
                                        <th width="20%">Leave Start Date</th>
                                        <th width="20%">Leave End Date</th>
                                        <th width="10%">Leave Reason</th>
                                        <th width="10%">Comment</th>
                                        <th width="10%">Status</th>
                                        <th width="10%">Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                    (userLeaves?.length > 0)? 
                                        userLeaves.map((item, index) => {
                                            return <tr key={`leaves-list-${index}`}>
                                                <td>{moment(Date.parse(item?.to)).isValid? moment(Date.parse(item?.to)).format("MMMM, DD YYYY, dddd") : '-'}</td>
                                                <td>{moment(Date.parse(item?.from)).isValid? moment(Date.parse(item?.from)).format("MMMM, DD YYYY, dddd") : '-'}</td>
                                                <td>{item?.leaveReason || '-'}</td>
                                                <td>{item?.rejectReason || '-'}</td>
                                                <td>{item?.status || '-'}</td>
                                                <td>
                                                    {currentLoggeInUserId !== activeUserId ? 
                                                        <button title="Add Coins" onClick={ ()=>openEditPage(item) } className="btn">
                                                        {" "}
                                                            <i className="fa fa-edit"></i>{" "}
                                                        </button> 
                                                        : '--'
                                                    }
                                                </td>
                                            </tr>
                                        }): <tr>
                                                <td colSpan="8" style={{"textAlign":"center"}}>
                                                    { !activeUserId? `Please Select a user from list`: `No leave request found` }
                                                </td>
                                            </tr>
                                    }
                                </tbody>
                                </table>   
                            </div>
                            </div>  
                        </> :
                            <div className="col-sm-12">
                            <div className="alert alert-warning text-center" role="alert"> No one come under this employee. </div>
                            </div>
                    }
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        <ModelBox
                data={{
                    size: "md", 
                    ...modelData,
                    content: modelContent,
                    title: "Update Leaves Status"
                }}
            />

            <MessageAlert
                id={msgCompId}
                type={ (()=>{
                    if(leavesProps.success){
                        return "success"
                    }else if(!leavesProps.success){
                        return "error"
                    }
                })()}
                message={leavesProps.message}
            />
        </React.Fragment>
    );
}
